import Icon from "@mui/material/Icon";
import { Route } from "App";
import { Sites } from "data/utils/globals";
import { Banner } from "layouts/aplicacoes/Banners";
import { Contact } from "layouts/aplicacoes/Contact";
import { FormsDefault } from "layouts/aplicacoes/FormsDefault";
import { Popups } from "layouts/aplicacoes/Popups";

const { id, path } = Sites.ECOINOVE;

export const ecoinoveRoutes: Route[] = [
  {
    type: "collapse",
    name: "ECOINOVE",
    key: "ECOINOVE",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    collapse: [
      {
        name: "Banners",
        key: `${path}/banners`,
        route: `${path}/banners`,
        component: <Banner.List idSite={id} path={path} />,
        permission: Banner.Permissions.list,
      },
      {
        type: "hide",
        name: " Novo Banner",
        key: `${path}/banners/new`,
        route: `${path}/banners/new`,
        component: <Banner.Create titleBox="adicionar banner" idSite={id} path={path} />,
        permission: Banner.Permissions.create,
      },
      {
        type: "hide",
        name: " Ver Banner",
        key: `${path}/banners/:id`,
        route: `${path}/banners/:id`,
        component: <Banner.Update idSite={id} path={path} />,
        permission: Banner.Permissions.update,
      },
      {
        type: "hide",
        name: " Editar Banner",
        key: `${path}/banners/edit/:id`,
        route: `${path}/banners/edit/:id`,
        component: <Banner.Update inicialEditing idSite={id} path={path} />,
        permission: Banner.Permissions.update,
      },

      {
        name: "Popups",
        key: `${path}/popups`,
        route: `${path}/popups`,
        component: <Popups.List idSite={id} path={path} />,
        permission: Popups.Permissions.list,
      },
      {
        type: "hide",
        name: " Novo",
        key: `${path}/popups/new`,
        route: `${path}/popups/new`,
        component: <Popups.Create idSite={id} path={path} />,
        permission: Popups.Permissions.create,
      },
      {
        name: "Atualizar",
        type: "hide",
        key: `${path}/popups/:id`,
        route: `${path}/popups/:id`,
        component: <Popups.Update idSite={id} path={path} />,
        permission: Popups.Permissions.update,
      },
      {
        name: "Contato",
        key: `${path}/contato`,
        route: `${path}/contato`,
        component: <Contact.List slug="ecoinove-contato" path={Sites.ECOINOVE.path} />,
        permission: Contact.Permissions.list,
      },
      {
        name: "Contato Editar",
        type: "hide",
        key: `${path}/contato/editar`,
        route: `${path}/contato/editar`,
        component: (
          <FormsDefault.Update
            slug="ecoinove-contato"
            redirectOnSave={`${path}/contato`}
            updatePermission={FormsDefault.PermissionsUpdate["ecoinove-contato"]}
          />
        ),
      },
    ],
  },
];
